import { render, staticRenderFns } from "./ChartOnHoldReasonPercent.vue?vue&type=template&id=9eff12f2"
import script from "./ChartOnHoldReasonPercent.vue?vue&type=script&lang=js"
export * from "./ChartOnHoldReasonPercent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports